import axios from "axios"
import accessToken from "./jwt-token-access/accessToken"
import store from "../store"

//pass new generated access token here
const state = store.getState()
const token = state?.Login?.token

//apply base url for axios
// const API_URL = "http://localhost:8888/api"
// const API_URL = "http://192.168.0.7:3001/api"
const API_URL = "https://apidev.pyne-mena.com"
// const API_URL = "https://api.pyne-mena.com/"

const axiosApi = axios.create({
  baseURL: API_URL,
})
// Define a callback function to update axiosApi with the new token
function updateAxiosApi(token) {
  axiosApi.defaults.headers.common["token"] = token
  // Perform any other actions you need with the new token
}

// Define a Proxy object to intercept changes to the token variable
const tokenProxy = new Proxy(
  { token: "" },
  {
    set(target, key, value) {
      if (key === "token") {
        updateAxiosApi(value)
      }
      target[key] = value
      return true
    },
  }
)

// Update the token using the Proxy object
tokenProxy.token = token
// axiosApi.defaults.headers.common["token"] = token

axiosApi.interceptors.response.use(
  response => response,
  error => Promise.reject(error)
)
export async function get(url, config = {}) {
  return await axiosApi.get(url, { ...config }).then(response => response.data)
}
export async function postMultipart(url, data, config = {}) {
  return axiosApi
    .post(
      url,
      { ...data },
      {
        headers: {
          accept: "application/json",
          "Accept-Language": "en-US,en;q=0.8",
          "Content-Type": `multipart/form-data`,
        },
      }
    )
    .then(response => response.data)
}
export async function post(url, data, config = {}) {
  return axiosApi.post(url, { ...data }).then(response => response.data)
}

export async function put(url, data, config = {}) {
  return axiosApi
    .put(url, { ...data }, { ...config })
    .then(response => response.data)
}

export async function del(url, config = {}) {
  return await axiosApi
    .delete(url, { ...config })
    .then(response => response.data)
}
